import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">MyTekHelp · Your Tech Support Partner</p>
        <h1>Empowering Your Tech Experience.</h1>
        <p className="lede">
          At MyTekHelp, we provide reliable tech support solutions tailored for everyday consumers. 
          Whether you need assistance with devices, software, or troubleshooting, we are here to help you navigate the tech world with ease.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Fast and Reliable Support</h2>
          <p>
            Our team is dedicated to providing quick resolutions to your tech issues, ensuring you can get back to what matters most.
          </p>
        </article>
        <article>
          <h2>Personalized Solutions</h2>
          <p>
            We understand that every tech challenge is unique. Our experts work with you to find the best solutions tailored to your needs.
          </p>
        </article>
        <article>
          <h2>Stay Updated</h2>
          <p>
            With MyTekHelp, you can stay informed about the latest tech trends and updates, ensuring you always have the knowledge you need.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;